import {
  BENEFITS_ERROR,
  BENEFITS_LOADING,
  BENEFITS_SUCCESS,
  EXCHANGES_ERROR,
  EXCHANGES_LOADING,
  EXCHANGES_SUCCESS,
  NEW_EXCHANGE_ERROR,
  NEW_EXCHANGE_LOADING,
  NEW_EXCHANGE_SUCCESS,
  CATEGORIES_ERROR,
  CATEGORIES_LOADING,
  CATEGORIES_SUCCESS,
  CURRENT_CATEGORY_SUCCESS,
  CURRENT_PRODUCT_CATEGORY_SUCCESS,
  POINTS_ERROR,
  POINTS_LOADING,
  POINTS_SUCCESS,
  BALANCE_LOADING,
  BALANCE_ERROR,
  BALANCE_SUCCESS,
  PRODUCTS_BY_CATEGORY_LOADING,
  PRODUCTS_BY_CATEGORY_ERROR,
  PRODUCTS_BY_CATEGORY_SUCCESS,
  OPEN_PRODUCT_MODAL_SUCCESS,
} from '../types/BankTypes';

const initialState = {
  benefits: {},
  benefitsStatus: 'idle',
  exchanges: [],
  exchangesStatus: 'idle',
  categories: [],
  categoriesStatus: 'idle',
  points: {},
  pointsStatus: 'idle',
  balance: [],
  balanceStatus: 'idle',
  productsByCategory: [],
  productsByCategoryStatus: 'idle',
  currentCategory: {},
  currentProductCategory: {},
  openProductModal: false,
  newExchange: {},
  newExchangeStatus: 'idle',
};

const bankReducer = (state = initialState, action) => {
  switch (action.type) {
    case BENEFITS_LOADING:
      return { ...state, benefitsStatus: 'loading' };
    case BENEFITS_ERROR:
      return { ...state, benefitsStatus: 'error' };
    case BENEFITS_SUCCESS:
      return {
        ...state,
        benefitsStatus: 'succeded',
        benefits: action.benefits,
      };
    case EXCHANGES_LOADING:
      return { ...state, exchangesStatus: 'loading' };
    case EXCHANGES_ERROR:
      return { ...state, exchangesStatus: 'error' };
    case EXCHANGES_SUCCESS:
      return {
        ...state,
        exchangesStatus: 'succeded',
        exchanges: action.exchanges,
      };
    case NEW_EXCHANGE_LOADING:
      return { ...state, newExchangeStatus: 'loading' };
    case NEW_EXCHANGE_ERROR:
      return { ...state, newExchangeStatus: 'error' };
    case NEW_EXCHANGE_SUCCESS:
      return {
        ...state,
        newExchangeStatus: 'succeded',
        newExchange: action.newExchange,
      };
    case CATEGORIES_LOADING:
      return { ...state, categoriesStatus: 'loading' };
    case CATEGORIES_ERROR:
      return { ...state, categoriesStatus: 'error' };
    case CATEGORIES_SUCCESS:
      return {
        ...state,
        categoriesStatus: 'succeded',
        categories: action.categories,
      };
    case CURRENT_CATEGORY_SUCCESS:
      return {
        ...state,
        currentCategory: action.currentCategory,
      };
    case CURRENT_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        currentProductCategory: action.currentProductCategory,
      };
    case OPEN_PRODUCT_MODAL_SUCCESS:
      return {
        ...state,
        openProductModal: action.openProductModal,
      };
    case POINTS_LOADING:
      return { ...state, pointsStatus: 'loading' };
    case POINTS_ERROR:
      return { ...state, pointsStatus: 'error' };
    case POINTS_SUCCESS:
      return { ...state, pointsStatus: 'succeded', points: action.points };
    case BALANCE_LOADING:
      return { ...state, balanceStatus: 'loading' };
    case BALANCE_ERROR:
      return { ...state, balanceStatus: 'error' };
    case BALANCE_SUCCESS:
      return {
        ...state,
        balanceStatus: 'succeded',
        balance: [...state.balance, action.balance],
      };
    case PRODUCTS_BY_CATEGORY_LOADING:
      return { ...state, productsByCategoryStatus: 'loading' };
    case PRODUCTS_BY_CATEGORY_ERROR:
      return { ...state, productsByCategoryStatus: 'error' };
    case PRODUCTS_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        productsByCategoryStatus: 'succeded',
        productsByCategory: action.productsByCategory.reverse(),
      };
    default:
      return state;
  }
};

export default bankReducer;
